export default __webpack_public_path__ + "static/C4_Charge-0d3f55c62e9d54c10b7954fbf812a662.png";